import { CommonPullupMenuComponent } from './../../modal-screens/common-pullup-menu/common-pullup-menu.component';
import { ActivatedRoute } from '@angular/router';
// compitition-service.ts ---
// line no 737 comment --- comprize

import { Component, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, NavController, NavParams, Platform } from '@ionic/angular';
import { adjustViewZIndex } from 'src/globals';
import { isPresent } from 'src/providers/common-service';
import { CompetitionService } from 'src/providers/competition-service/competition-service';
import {
  CompetitionCategory,
  CompetitionInfo,
  CompetitionPrizeInfo,
  GameroundPrize,
} from './../../../../data/competition-data';
import {Location} from '@angular/common';

@Component({
  selector: 'app-competition-prizes',
  templateUrl: './competition-prizes.page.html',
  styleUrls: ['./competition-prizes.page.scss'],
})
export class CompetitionPrizesPage implements OnInit {
  public competition: CompetitionInfo;
  public prizes: Array<CompetitionPrizeInfo>;
  public roundNo: Array<number> = new Array<number>();
  public prizeMap: any = {};
  public compPrizes: Array<CompetitionPrizeInfo> = [];
  public roundwisePrizes: Array<Array<CompetitionPrizeInfo>> = [];
  public categories: Array<CompetitionCategory> =
    new Array<CompetitionCategory>();

  public gameRoundPrizes: Array<GameroundPrize> = [];

  public teamRoundwisePrizes: Array<Array<CompetitionPrizeInfo>> = [];
  public teamPrizes: Array<CompetitionPrizeInfo>;
  public compTeamPrizes: Array<CompetitionPrizeInfo> = [];
  public gameRoundTeamPrizes: Array<GameroundPrize> = [];

  appFooterHide: boolean = true;
  searchQuery: string = '';

  compId: number;

  showPrizeTab: string = 'individual'; //team
  constructor(
    private router: Router,
    private nav: NavController,
    private navParams: NavParams,
    private renderer: Renderer2,
    private competitionService: CompetitionService,
    private route: ActivatedRoute,
    private location: Location,
    private modalCtl: ModalController,
    private platform: Platform
  ) {
    if(!this.router.getCurrentNavigation().extras.state){
      this.onHomeClick()
    }
    this.competition = this.router.getCurrentNavigation().extras.state.competition;
    this.compId = this.router.getCurrentNavigation().extras.state.compId;
    this.prizes = this.router.getCurrentNavigation().extras.state.prizes;
    this.teamPrizes = this.router.getCurrentNavigation().extras.state.teamPrizes;
    this.categories = this.router.getCurrentNavigation().extras.state.categories;
      this.prizeMap = {};


      this.prizes.forEach((pr: CompetitionPrizeInfo) => {
        if (pr.roundNumber >= 99){
          this.compPrizes.push(pr);
        }
        else {
          if (!isPresent(this.roundwisePrizes[pr.roundNumber]))
            this.roundwisePrizes[pr.roundNumber] = [];
          this.roundwisePrizes[pr.roundNumber].push(pr);
        }
      });
      //
      this.gameRoundPrizes = this.competitionService.groupedPrizes(this.prizes);
      //
      this.teamPrizes.forEach((pr: CompetitionPrizeInfo) => {
        if (pr.roundNumber >= 99) this.compTeamPrizes.push(pr);
        else {
          if (!isPresent(this.teamRoundwisePrizes[pr.roundNumber]))
            this.teamRoundwisePrizes[pr.roundNumber] = [];
          this.teamRoundwisePrizes[pr.roundNumber].push(pr);
        }
      });
      this.gameRoundTeamPrizes = this.competitionService.groupedPrizes(
        this.teamPrizes
      );


      console.debug("game round prizes : ", this.gameRoundPrizes);

  }
  ngOnInit() {}

  ionViewDidEnter() {
    adjustViewZIndex(this.nav, this.renderer);
  }

  prizesExist(roundNumber: number) {
    if (
      isPresent(this.roundwisePrizes[roundNumber]) &&
      this.roundwisePrizes[roundNumber].length > 0
    )
      return true;
    else return false;
  }

  teamPrizesExist(roundNumber: number) {
    if (
      isPresent(this.teamRoundwisePrizes[roundNumber]) &&
      this.teamRoundwisePrizes[roundNumber].length > 0
    )
      return true;
    else return false;
  }

  onHomeClick() {
    this.router.navigate(['tabs/player-home']);
  }

  public getHandicapRange(category: string) {
    // console.log("getHandicapRange() ",category)
    let handicapRange: string = '';
    this.categories.forEach((c: CompetitionCategory) => {
      // console.log("getHandicapRange() ",category,c.categoryName,c.fromHandicap,c.toHandicap)
      if (category === c.categoryName) {
        // console.log("getHandicapRange() inside",category,c.categoryName,c.fromHandicap,c.toHandicap)
        if(!c?.forGrouping) {
          handicapRange = '';
        } else handicapRange = ' (' + c.fromHandicap + ' - ' + c.toHandicap + ')';
      }
    });
    return handicapRange;
  }


  onBackpage() {
    this.location.back();
    // console.log('Boook');
    // this.router.navigate(['tabs/competition-details']);
  }
  goHome() {
    this.router.navigate(['tabs/player-home']);
  }

  async onDisplayPrizeDetails(prize: CompetitionPrizeInfo) {
    let _category = prize.categoryName?prize.categoryName:'';
    let _title = `Prize for ${_category} - ${prize.title}`;
    if(prize.playerPos) {
      _title = `Prize for ${prize.playerPos}`;
    }
    let _message = {
      content: `${prize.prizeName}`
    }

    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
          app: null,
          mode: 'infoDisplay',
          headerTitle: _title,
          message: _message,
      }
  })
  await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
  });
  modal.onDidDismiss().then((data: any) => {

  })
  }
  // filteredGameRoundPrizes() {
  //   let _filtered = [];
  //   if(this.searchQuery?.length > 0) {
  //     _filtered = this.gameRoundPrizes.filter((grp: GameroundPrize) => {
  //       // if(grp.)
  //     })
  //   } else _filtered = this.gameRoundPrizes;
  //   return _filtered;
  // }
}
